import { createAction } from 'redux-actions'

export const onSetGeoLocation = createAction('SET_GEO_LOCATION')
export const onUpdateBatteryLevel = createAction('UPDATE_BATTERY_LEVEL', (action) => action.batteryLevel)
